var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigurationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M3.257 11.439c.15.512.357 1.006.619 1.47l-.747.942c-.244.308-.217.747.058 1.025l1.286 1.287c.278.277.717.302 1.025.058l.936-.741c.482.277.994.494 1.528.646l.14 1.205c.046.39.375.683.766.683h1.82c.39 0 .72-.293.765-.683l.135-1.162c.573-.15 1.122-.372 1.637-.662l.906.717c.308.244.747.216 1.024-.058l1.287-1.287c.278-.278.302-.717.058-1.025l-.704-.893c.292-.507.521-1.047.674-1.61l1.085-.126c.39-.046.683-.375.683-.765V8.639c0-.39-.293-.72-.683-.766l-1.07-.125c-.147-.558-.366-1.092-.647-1.592l.66-.832c.243-.308.216-.748-.059-1.025l-1.284-1.284c-.277-.278-.716-.302-1.024-.058l-.808.64c-.525-.308-1.086-.542-1.674-.701l-.122-1.046c-.046-.39-.375-.683-.766-.683h-1.82c-.39 0-.72.292-.766.683l-.122 1.046c-.603.162-1.18.406-1.716.726l-.839-.665c-.308-.244-.747-.217-1.024.058L3.187 4.302c-.278.277-.302.717-.058 1.025l.701.887c-.28.506-.494 1.046-.634 1.607l-1.122.129c-.39.045-.683.375-.683.765v1.82c0 .391.292.72.683.766l1.183.138z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M9.814 11.807c1.225 0 2.217-.992 2.217-2.216 0-1.225-.992-2.217-2.217-2.217-1.224 0-2.216.992-2.216 2.217 0 1.224.992 2.216 2.216 2.216z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurationIcon);
export default __webpack_public_path__ + "static/media/configuration-icon.445dc030d68de843d64fc960a152c656.svg";
export { ForwardRef as ReactComponent };